// DS: i3.37
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import IconWrap from '../../IconWrap';
const ReusePrompt = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, _object_spread_props(_object_spread({}, props), {
        disableDefaultColors: true
    }), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        d: "M12.159 3.467a.94.94 0 000-1.331.944.944 0 00-1.334 0L8.193 4.762a.8.8 0 000 1.132l2.632 2.627a.944.944 0 001.334 0 .94.94 0 000-1.331l-1.073-1.071A7.11 7.11 0 0117.03 8.14a7.09 7.09 0 010 10.04 7.124 7.124 0 01-10.06 0 7.075 7.075 0 01-2.056-5.652.943.943 0 00-1.879-.166 8.955 8.955 0 002.601 7.15c3.515 3.507 9.213 3.507 12.728 0a8.97 8.97 0 000-12.703 8.99 8.99 0 00-6.936-2.613l.73-.73z"
    })));
};
ReusePrompt.displayName = 'ReusePrompt';
export default ReusePrompt;

//# sourceMappingURL=ReusePrompt.js.map